import { Page } from "components/ui";
import { useDispatch } from "react-redux";
import TimeSlotSearchForm from "./time-slot-search-form";
import { scheduleChat } from "actions/chat";
import useTranslate from "hooks/use-translate-language";
import useDocumentTitle from "hooks/use-document-title";
import { useLocation } from "react-router-dom";
import queryString from "query-string";

const ScheduleChat = () => {
  const location = useLocation();
  const translate = useTranslate();
  const dispatch = useDispatch();

  useDocumentTitle(translate("scheduleAMeeting"));

  const tokenString = queryString.parse(location.search)?.token;
  
  return (
    <Page.Container>
      <Page.Header title={translate("scheduleAMeeting")} goBack />
      <Page.Content>
        <TimeSlotSearchForm
          handleTimeSlotSelect={async (chat) => {
            await dispatch(scheduleChat(chat));
          }}
        />
      </Page.Content>
    </Page.Container>
  );
};

export default ScheduleChat;
